import { CompanyId } from '@business/entities/companies';
import { CurrencyID, CurrencyResponse } from '@business/entities/currency';
import { Endpoint } from '../endpoint';

export function fetchCurrencies() {
  return Endpoint.get<CurrencyResponse[]>(`@gc/currency`);
}

export function createCurrency(companyId: CompanyId, data: Partial<CurrencyResponse>) {
  return Endpoint.post<CurrencyResponse>(`@gc/currency`, { params: { companyId: companyId, currency: data.name } });
}
export function updateCurrency(currencyId: CurrencyID, rate: number) {
  return Endpoint.patch<CurrencyResponse>(`@gc/currency/${currencyId}`, { params: { currencyId: currencyId, rate: rate } });
}

export function deleetCurrency(id: CurrencyID) {
  return Endpoint.delete<void>(`@gc/currency/${id}`);
}

export function syncCurrencies() {
  return Endpoint.get<CurrencyResponse[]>(`@gc/currency/sync`);
}
